/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-col-count-by-screen',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoColCountByScreenComponent extends NestedOption {
    @Input()
    get lg(): number {
        return this._getOption('lg');
    }
    set lg(value: number) {
        this._setOption('lg', value);
    }

    @Input()
    get md(): number {
        return this._getOption('md');
    }
    set md(value: number) {
        this._setOption('md', value);
    }

    @Input()
    get sm(): number {
        return this._getOption('sm');
    }
    set sm(value: number) {
        this._setOption('sm', value);
    }

    @Input()
    get xs(): number {
        return this._getOption('xs');
    }
    set xs(value: number) {
        this._setOption('xs', value);
    }


    protected get _optionPath() {
        return 'colCountByScreen';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoColCountByScreenComponent
  ],
  exports: [
    DxoColCountByScreenComponent
  ],
})
export class DxoColCountByScreenModule { }
